{
  "it": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Contattami",
        "failure": "Si è verificato un errore imprevisto.",
        "success": "La contatteremo a breve."
      }
    }
  }
}
